<template>
  <span class="vcita-meter" :class="{'single-line': singleLine}">
    <VSvgIcon tag="28" size="28" :icon="icon" class="vcita-meter-icon"/>
    <div class="vcita-meter-title">{{title}}</div>
    <div class="vcita-meter-value">{{value}}</div>
  </span>
</template>
<script>
import {VSvgIcon} from '@/modules/common/components'

export default {
  name: 'VcitaMeter',
  components: {
    VSvgIcon
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    singleLine: {
      type: Boolean,
      default: false
    }
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import '@/assets/scss/abstract/_i18n-mixins';

.vcita-meter {
  display: grid;
  grid-template-areas:
    "icon title"
    "icon value";

  &.single-line{
    grid-template-areas: "icon title value";
    grid-template-columns: 40px auto auto;
    width: 100%;
    align-items: center;

    .vcita-meter-value {
      display: flex;
      justify-content: flex-end;
    }
  }

  .vcita-meter-icon {
    @include i-margin-mirror(0, 12px);
    grid-area: icon;
  }

  .vcita-meter-title {
    font-family: var(--primary-font-family);
    font-size: 12px;
    font-weight: 500;
    color: $grey-color-14;
    grid-area: title;
  }

  .vcita-meter-value {
    font-family: var(--primary-font-family);
    font-size: 14px;
    font-weight: 500;
    line-height: 1.29;
    color: $blue-color-2;
    grid-area: value;
  }
}
</style>
